import { useEffect, useState } from 'react'
import * as storeApi from '@/services/storeService'

/** True when at least one organisation store has **posEnabled** (set by platform admin). */
export function usePosNavVisible(enabled: boolean) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!enabled) {
      setVisible(false)
      return
    }
    let cancelled = false
    storeApi
      .listStores()
      .then((r) => {
        if (!cancelled) setVisible((r.items ?? []).some((s) => s.posEnabled === true))
      })
      .catch(() => {
        if (!cancelled) setVisible(false)
      })
    return () => {
      cancelled = true
    }
  }, [enabled])

  return visible
}
